import { render, staticRenderFns } from "./suporte-liberar-acesso.vue?vue&type=template&id=a093ed10"
import script from "./suporte-liberar-acesso.vue?vue&type=script&lang=ts"
export * from "./suporte-liberar-acesso.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports